import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_263 implements Validator {

	public static id = 'CTRL_263';
	private message = 'error.ctr_263';


	public LOG: LogService = new LogService(CTRL_263);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_263.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const controls =
					this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const secondWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
				const thirdWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
				const firstCtrl = form.controls[firstWithStepId];
				const secondCtrl = form.controls[secondWithStepId];
				const thirdCtrl = form.controls[thirdWithStepId];

				if (this.isEmptyOrNullOrUndefined(firstCtrl) ||
					this.isEmptyOrNullOrUndefined(secondCtrl) ||
					this.isEmptyOrNullOrUndefined(thirdCtrl)) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	isEmptyOrNullOrUndefined(ctrl): boolean {
		return (ctrl === undefined || ctrl === null || ctrl.value === undefined || ctrl.value === null || ctrl.value === '');
	}
}
